module.exports = __webpack_public_path__ + "img/p01.a4c7f7f9.png";